import { useParams, usePathname } from 'next/navigation';

import useSocialProfiles from '@/hooks/swr/useSocialProfiles';

// Utils
import { formatUrls } from '@/utils/urls/formatUrl';

import { pagesWithoutSocialProfile } from '@/lib/middleware/accessControl/pagesWithoutSocialProfile';
// Lib
import { NO_ACTIVE_SOCIAL_PROFILE, SOCIAL_PROFILES } from '@/lib/routes/privateRoutes';

export const useRequiresProfile = () => {
    const params = useParams();
    const pathname = usePathname();

    /**
     * Get the social profiles (all) and activated social profiles
     */
    const { socialProfiles, activatedSocialProfiles, isLoading } = useSocialProfiles({
        revalidateIfStale: false
    });

    /**
     * Replace url parameters with the real value
     */
    const formattedUrl = formatUrls(pagesWithoutSocialProfile, params);

    /**
     * Check if the user has access to the page
     * - If no social profiles exist at all, redirect to /social-profiles
     * - If social profiles exist but none are activated, redirect to /no-active-sp
     */
    const isPageWithoutSocialProfileRequired = formattedUrl.includes(pathname);

    if (isPageWithoutSocialProfileRequired || isLoading) {
        return { hasAccess: true, redirect_url: null };
    }

    if (!socialProfiles.length) {
        return { hasAccess: false, redirect_url: SOCIAL_PROFILES };
    }

    if (!activatedSocialProfiles.length) {
        return { hasAccess: false, redirect_url: NO_ACTIVE_SOCIAL_PROFILE };
    }

    return { hasAccess: true, redirect_url: null };
};
